import React from "react";
import "./Careers.css";
import HeroSVG from "./IMG/CareersHero.svg";
import JobImage from "./IMG/1.png";
import TailorImage from "./IMG/tailor.png";
import ExhibitionCoordinatorImage from "./IMG/ExhibitionCoordinator.png";
import NavBar from "../Navigation/NavBar";
import Footer from "../Footer/Footer";
import WhatsAppWidgetComponent from "../Whatsapp/WhatsAppWidgetComponent";
import { Helmet } from "react-helmet-async";

function Careers() {
  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="careers-page">
      <Helmet>
        <title>Careers — Quarec Resources</title>
      </Helmet>
      <NavBar />
      <section className="careers-hero">
        <div className="hero-content">
          <h1>Join Our Team</h1>
          <p className="subtitle">We are hiring immediately — grow with Quarec</p>
          <a href="/ApplyJob" className="apply-btn">Apply Now</a>
        </div>
        <div className="hero-visual">
          <img src={HeroSVG} alt="Careers hero" />
        </div>
      </section>
      <section className="job-card">
        <div className="job-card-inner" style={{ gridTemplateColumns: "1fr 50%",padding: "50px" }}>
          <div className="job-header">
            <h2>🚨 Fresher Hiring – Female Exhibition Coordinator</h2>
            <div className="job-meta">
              <img src={ExhibitionCoordinatorImage} style={{ width: "100%" }} alt="Exhibition Coordinator role" />
            </div>
          </div>

          <div className="job-body" style={{ marginTop: "20px" }}>
            <p>📍 Ahmedabad (Head Office)</p>
            <p>✈️ Pan India + International Travel</p>
            <ul style={{ marginLeft: "20px", listStyleType: "disc" }}>
              <li> Freshers welcome</li>
              <li> Strong communication skills</li>
              <li> Willing to travel (India &amp; Abroad)</li>
            </ul>
             <p>📩 Interested? Send CV at</p>
            <p className="contact">
              <a href="tel:9898850528">9898850528</a>
            </p>
          </div>
        </div>
      </section>
      <section className="job-card">
        <div className="job-card-inner">
          <div className="job-header">
            <div className="job-meta" style={{ marginTop: "0px" }}>
              <img src={TailorImage} style={{ width: "100%",marginTop: "0px" }} alt="Tailor &amp; Master role" />
            </div>
          </div>

          <div className="job-body">
          </div>
          <div className="job-cta">
              <p>Interested candidates can reach us at</p>
              <p className="contact">
                <a href="tel:9898850528">9898850528</a> Or <a href="mailto:career4@quarec.com">career4@quarec.com</a>
              </p>
              <a href="mailto:career4@quarec.com" className="apply-cta">Share CV</a>
            </div>
        </div>
        
      </section>
      <section className="job-card">
        <div className="job-card-inner">
          <div className="job-header">
            <h2><b>Urgent Hiring For Performance Marketing Specialist</b></h2>
            <div className="job-meta">
              {/* <span>Experience: <strong>2+ Years</strong></span>
              <span>Location: <strong>Ahmedabad (Ashram Road)</strong></span>
              <span>Salary: <strong>No Bar for right candidate</strong></span> */}
              <img src={JobImage} style={{ width: "680px"}} alt="Job position" />
            </div>
          </div>

          <div className="job-body">
            <h3>What we are looking for</h3>
            <ol>
              <li>
                Own and optimize paid campaigns across Google, Meta, LinkedIn, and other performance channels with a clear focus on ROI.
              </li>
              <li>
                Drive full-funnel growth by managing budgets, testing creatives, improving conversions, and lowering CPL/CAC.
              </li>
              <li>
                Track, analyze, and report performance daily, taking fast data-backed decisions to scale what works.
              </li>
            </ol>

            <div className="job-cta">
              <p>Interested Candidate can share their CV at</p>
              <p className="contact">
                <a href="tel:9898850528">9898850528</a> Or <a href="mailto:career4@quarec.com">career4@quarec.com</a>
              </p>
              <a href="mailto:career4@quarec.com" className="apply-cta">Share CV</a>
            </div>
          </div>
        </div>
      </section>

     
      <Footer />
      <WhatsAppWidgetComponent />
    </div>
  );
}

export default Careers;
